/**
 * The available screen types.
 */
enum ScreenTypes
{
  IdleScreen = '',
  Redirect = 'Redirect',
  LargeBooking = 'LargeBooking',
}

export default ScreenTypes;
